import { useState } from "react";
import { Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../../components/ui/button";
import { errorMessage, syncExternalCodes } from "../api";

/** Grava o id do produto como `externalCode` nos itens do iFood: o pedido passa a
 *  chegar com o produto casado (estoque, ficha, NCM) sem vincular na mão. */
export default function CasarCodigosCard({ onDone }) {
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);

  const run = async () => {
    setBusy(true);
    try {
      const r = await syncExternalCodes();
      setReport(r);
      if (r.success) toast.success(`${r.updated} códigos gravados no iFood · ${r.auto_mapped} vínculos automáticos`);
      else toast.error(r.message || "Nada para sincronizar", { duration: 9000 });
      onDone?.();
    } catch (e) {
      toast.error(errorMessage(e, "Erro ao casar códigos"), { duration: 9000 });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-4 rounded-xl border bg-card">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex-1">
          <p className="font-medium text-sm flex items-center gap-2"><Link2 className="w-4 h-4" /> Casar códigos com o iFood</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Grava o código do produto do Núcleo em cada item do seu cardápio no iFood. Item com o mesmo nome vincula sozinho;
            depois disso todo pedido chega com o produto certo (estoque, ficha técnica e nota).
          </p>
        </div>
        <Button size="sm" onClick={run} disabled={busy} className="bg-red-500 hover:bg-red-600 text-white shrink-0">
          {busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Link2 className="w-4 h-4 mr-1" />} Casar códigos
        </Button>
      </div>
      {report && (
        <div className="mt-3 text-xs rounded-lg bg-muted/40 p-3 space-y-1">
          {report.success ? (
            <>
              <p><b>{report.total_items}</b> itens no iFood · <b>{report.updated}</b> códigos gravados · <b>{report.already_ok}</b> já estavam certos · <b>{report.auto_mapped}</b> vinculados pelo nome{report.errors ? <> · <span className="text-red-600">{report.errors} com erro</span></> : null}</p>
              {report.unmatched?.length > 0 && (
                <p className="text-muted-foreground">Sem produto igual no Núcleo ({report.unmatched.length}): {report.unmatched.slice(0, 12).join(", ")}{report.unmatched.length > 12 ? "…" : ""} — vincule na lista abaixo.</p>
              )}
            </>
          ) : <p className="text-amber-700 dark:text-amber-400">{report.message}</p>}
        </div>
      )}
    </div>
  );
}
